<tree-multi-select-dropdown
  *ngLet="changeSelected | async as changeSelected"
  [placeholder]="'Select...'"
  [options]="options || []"
  [filterable]="true"
  [exact]="true"
  [selectedOptions]="selected | async"
  (selectedOptionsChange)="changeSelected($event)"
  [analyticsEvents]="{ selected: analyticsEvents.clicked }"
  [loadable]="loadable"
></tree-multi-select-dropdown>
